export default __webpack_public_path__ + "static/first-place-38fcfe32e36726589b9cf401319fec9b.png";